import React from 'react';
import HorizontalPressBox from '../../components/PressBox/HorizontalPressBox';
import VerticalPressBox from '../../components/PressBox/VerticalPressBox';

import {highlightPress, pressInfo} from '../../constants/data';
import styles from './pressList.module.css';

const PressList = () => {
  return (
    <div className={styles.app__press_list}>
      <div className={styles.app__press_list_grid}>
        {pressInfo.map((item, index) => {
          return (
            <HorizontalPressBox
              className={styles.app__press_list_horizontal}
              key={index}
              item={item}/>);
        })}
        <div className={styles.app__press_list_vertical}>
          <VerticalPressBox
            key={999}
            item={highlightPress[0]}/>
        </div>
      </div>
    </div>
  );
};

export default PressList;
